// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2ha_0","colMaxWidth":"Table_colMaxWidth__zvKGo"};